export enum AttendanceRate {
    Weekly = 1,
    Fortnightly = 2,
    Monthly = 3
}
